import type * as React from 'react';
import { get } from '@Domain/Api';
import beneficiariesFetched, {
	type BeneficiariesFetchedAction,
	type BeneficiariesFetchedPayload,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiariesFetched';
import beneficiariesFetchFailed, {
	type BeneficiariesFetchFailedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiariesFetchFailed';
import type FetchBeneficiaries from '@Application/Beneficiaries/Beneficiaries/Queries/FetchBeneficiaries';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = BeneficiariesFetchedAction | BeneficiariesFetchFailedAction;

export default (query: FetchBeneficiaries) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Server-side pagination: `get` is used deliberately, never `getPaginated` (which walks every
			// page and would make `totalRecords` lie to the paginator).
			const baseUrl = `${parameters.api.host}/api/accounts/${query.accountId}/beneficiaries`;
			const queryString = query.toQueryString();
			const url = queryString.length > 0 ? `${baseUrl}?${queryString}` : baseUrl;

			const payload = await get<BeneficiariesFetchedPayload>(url);

			const action = beneficiariesFetched(payload, query.accountId, queryString);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiariesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
